(function(){
  const REF_KEY = 'finallyReliefReferral';
  const OWN_KEY = 'finallyReliefOwnReferral';
  const params = new URLSearchParams(window.location.search);

  function getWithExpiry(key){
    try{
      const raw = localStorage.getItem(key);
      if(!raw) return null;
      const data = JSON.parse(raw);
      if(data.expiresAt && Date.now() > data.expiresAt){
        localStorage.removeItem(key);
        return null;
      }
      return data;
    }catch(e){ return null; }
  }

  function setWithExpiry(key, value, days){
    try{
      const expiresAt = Date.now() + (days * 24 * 60 * 60 * 1000);
      localStorage.setItem(key, JSON.stringify(Object.assign({}, value, { expiresAt: expiresAt })));
    }catch(e){}
  }

  function cleanCode(value){
    return (value || '').toString().trim().replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 48);
  }

  function createShareCode(){
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    let code = 'FR-';
    const arr = new Uint8Array(8);
    crypto.getRandomValues(arr);
    for(let j = 0; j < 8; j++) code += chars[arr[j] % chars.length];
    return code;
  }

  function buildShareLink(baseUrl, code){
    try{
      const url = new URL(baseUrl, window.location.origin);
      url.searchParams.set('ref', code);
      return url.toString();
    }catch(e){
      const fallback = baseUrl || window.location.href.split('?')[0];
      return fallback + (fallback.indexOf('?') === -1 ? '?' : '&') + 'ref=' + encodeURIComponent(code);
    }
  }

  function saveIncomingReferral(days){
    const incomingCode = cleanCode(params.get('ref') || params.get('r') || params.get('referral'));
    if(!incomingCode) return;
    setWithExpiry(REF_KEY, {
      code: incomingCode,
      url: window.location.href,
      path: window.location.pathname,
      capturedAt: new Date().toISOString()
    }, days);
  }

  function hydrateRoot(root){
    const days = parseInt(root.dataset.storageDays || '90', 10);
    saveIncomingReferral(days);

    const launchUrl = root.dataset.launchUrl || window.location.href.split('?')[0];
    const form = root.querySelector('form');
    const emailInput = root.querySelector('[data-fr-email]');
    const referrerCodeInput = root.querySelector('[data-fr-referrer-code]');
    const referrerUrlInput = root.querySelector('[data-fr-referrer-url]');
    const shareCodeInput = root.querySelector('[data-fr-share-code]');
    const shareLinkHiddenInput = root.querySelector('[data-fr-share-link-hidden]');
    const utmSourceInput = root.querySelector('[data-fr-utm-source]');
    const utmMediumInput = root.querySelector('[data-fr-utm-medium]');
    const utmCampaignInput = root.querySelector('[data-fr-utm-campaign]');
    const sharePanel = root.querySelector('[data-fr-share-panel]');
    const shareLinkField = root.querySelector('[data-fr-share-link]');
    const copyButton = root.querySelector('[data-fr-copy-link]');
    const feedback = root.querySelector('[data-fr-copy-feedback]');
    const nativeShareButton = root.querySelector('[data-fr-native-share]');
    const emailShareLink = root.querySelector('[data-fr-email-share]');

    const incoming = getWithExpiry(REF_KEY);
    const own = getWithExpiry(OWN_KEY);

    if(referrerCodeInput && incoming && incoming.code) referrerCodeInput.value = incoming.code;
    if(referrerUrlInput && incoming && incoming.url) referrerUrlInput.value = incoming.url;
    if(utmSourceInput) utmSourceInput.value = params.get('utm_source') || '';
    if(utmMediumInput) utmMediumInput.value = params.get('utm_medium') || '';
    if(utmCampaignInput) utmCampaignInput.value = params.get('utm_campaign') || '';

    function showShare(link){
      if(!sharePanel || !shareLinkField) return;
      shareLinkField.value = link;
      sharePanel.hidden = false;
      if(emailShareLink){
        const subject = encodeURIComponent('Join me on the finallyRelief! early access list');
        const body = encodeURIComponent('I joined the finallyRelief! early access list. Use my referral link to sign up: ' + link);
        emailShareLink.href = 'mailto:?subject=' + subject + '&body=' + body;
      }
    }

    if(own && own.code){
      const existingLink = own.link || buildShareLink(launchUrl, own.code);
      showShare(existingLink);
      if(shareCodeInput) shareCodeInput.value = own.code;
      if(shareLinkHiddenInput) shareLinkHiddenInput.value = existingLink;
    }

    if(form){
      var submitted = false;
      form.addEventListener('submit', function(){
        if(submitted) return;
        submitted = true;
        const email = emailInput ? emailInput.value : '';
        const code = (own && own.code) ? own.code : createShareCode();
        const link = buildShareLink(launchUrl, code);
        if(shareCodeInput) shareCodeInput.value = code;
        if(shareLinkHiddenInput) shareLinkHiddenInput.value = link;
        setWithExpiry(OWN_KEY, {
          code: code,
          email: email,
          link: link,
          createdAt: new Date().toISOString()
        }, days);
        showShare(link);
      });
    }

    /* FIXED: Only scroll to the panel if the user just submitted the form. 
       This prevents jumping on every page load for returning visitors.
    */
    const isSuccessRedirect = window.location.search.includes('customer_posted=true');
    if(isSuccessRedirect && sharePanel && !sharePanel.hidden){
      setTimeout(function(){
        sharePanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 500);
    }

    if(copyButton && shareLinkField){
      copyButton.addEventListener('click', async function(){
        try{
          await navigator.clipboard.writeText(shareLinkField.value);
          if(feedback){ feedback.textContent = 'Referral link copied.'; setTimeout(function(){ feedback.textContent = ''; }, 3000); }
        }catch(e){
          shareLinkField.select();
          document.execCommand('copy');
          if(feedback){ feedback.textContent = 'Referral link copied.'; setTimeout(function(){ feedback.textContent = ''; }, 3000); }
        }
      });
    }

    if(nativeShareButton && shareLinkField){
      nativeShareButton.addEventListener('click', async function(){
        const link = shareLinkField.value;
        if(navigator.share){
          try{
            await navigator.share({ title: 'finallyRelief! early access', text: 'Join me on the finallyRelief! early access list.', url: link });
          }catch(e){}
        }else if(copyButton){
          copyButton.click();
        }
      });
    }
  }

  function initAllRoots() {
    document.querySelectorAll('[data-fr-referral-root]').forEach(hydrateRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllRoots);
  } else {
    initAllRoots();
  }

  document.addEventListener('shopify:section:load', function(e) {
    var root = e.target.querySelector('[data-fr-referral-root]');
    if (root) hydrateRoot(root);
  });
})();